<template>
  <div id="nuevos-consorcios">
    <ca-empty-state
      v-if="!consorcios_pendientes_copy.length"
      icon="apartment"
      texto_principal="No hay nuevos consorcios"
      class="mt-10">

      <div slot="texto-secundario">
        <p class="texto-secundario">Aquí verás la lista de consorcios activados <br> que aún no tienen acuerdo comercial</p>
      </div>
    </ca-empty-state>

    <template v-else>
      <div class="tabla-container pt-2 pb-4">

        <div class="d-flex justify-space-between align-center">
          <div class="d-flex align-center">
            <div class="ca-filtro">
              <ca-filtro
                :items_sin_filtrar="consorcios_pendientes_copy"
                :keys="['administracion.nombre','nombre','tipo','cantidad_ufs_facturables','fecha_creacion','administracion.id','id','administracion.admin_ppal_mail', 'administracion.agente', 'jira.informador', 'jira.estado_cliente']"
                :items.sync="consorcios_pendientes_filtro"
                :filtro.sync="filtro"
                placeholder="Filtrar por administración, consorcio y tipo"
                :disabled="loading_tabla"
              />
            </div>

            <!-- Chip totalizador consorcios seleccionados -->
            <ca-chip v-if="consorciosSeleccionados.length" :item="contenidoChipConsorciosSeleccionados" disabled cantidad_bold invertir class="ml-6 mr-0 chip-totalizador" />

            <!-- Chip totalizador de UFs de los consorcios seleccionados -->
            <ca-chip v-if="consorciosSeleccionados.length" :item="contenidoChipUfsConsorciosSeleccionados" disabled cantidad_bold invertir class="ml-2 chip-totalizador" />
          </div>

          <div
            v-if="consorciosSeleccionados.length"
            class="archivar-consorcios"
            @click="archivarConsorciosSeleccionados()"
          >
            <span class="material-symbols-outlined mr-2 icono-archivar">archive</span>
            <span class="label-archivar-consorcios">Ocultar seleccionados</span>
          </div>
        </div>

        <div class="tabla-nuevos-consorcios">
          <ca-tabla
            :items="itemsTabla"
            :headers="headers"
            :loading="loading_tabla"
            loading_text="Buscando nuevos consorcios..."
            filas_hover
            header_fijo
            columna_seleccionar_todo
            scrollable
            @select-all="seleccionoTodo($event)"
          >
            <template slot="item" slot-scope="props">
              <tr :class="{'background-fila-seleccionada': props.item.seleccionado }">

                <!-- Checkbox -->
                <td>
                  <v-checkbox
                    class="tabla-checkbox"
                    color="accent"
                    v-model="props.item.seleccionado"
                    @change="seleccionoConsorcio(props.item, $event)"
                  />
                </td>

                <!-- Ticket de Jira + Informador -->
                <td>
                  <div class="d-flex align-center">
                    <ca-tooltip-jira :ticket_jira="props.item.ticketJira" />
                    <span class="texto-mostrado ml-2" v-if="props.item.jira" :title="props.item.jira.informador">{{ props.item.jira.informador }}</span>
                  </div>
                </td>

                <!-- Descuento (oculta temporalmente)
                <td :title="props.item.jira ? props.item.jira.descuento : ''">
                  <span v-if="props.item.jira">{{ props.item.jira.descuento }}</span>
                </td>
                 -->

                <!-- Estado cliente -->
                <td :title="props.item.jira ? props.item.jira.estado_cliente : ''">
                  <span v-if="props.item.jira">{{ props.item.jira.estado_cliente }}</span>
                </td>

                <!-- Administración -->
                <td :title="tituloTooltipAdministracion(props.item.administracion)">
                  <span>[{{ props.item.administracion.id }}] {{ props.item.administracion.nombre }}</span>
                </td>

                <!-- Consorcio -->
                <td :title="props.item.nombre_consorcio_con_tipo_tooltip_formateado">
                  <div class="d-flex align-center">
                    <div class="d-flex">
                      <span class="material-symbols-outlined icono-tipo-consorcio mr-2">{{ props.item.tipo === 'edificio' ? 'domain' : 'nature' }}</span>
                      <span class="texto-mostrado">[{{ props.item.id }}] {{ props.item.nombre }}</span>
                    </div>
                  </div>
                </td>

                <!-- UFs Facturables -->
                <td class="d-flex justify-center align-center">
                  <span> {{ props.item.cantidad_ufs_facturables }}</span>
                </td>

                <!-- Agente -->
                <td :title="props.item.administracion.agente">
                  <span>{{ props.item.administracion.agente }}</span>
                </td>

                <!-- Creación -->
                <td>
                  <span>{{ props.item.fecha_creacion | formatFecha("dd/MM/yyyy") }}</span>
                </td>

                <!-- Columan de relleno, para completar toda la tabla -->
                <td></td>
              </tr>
            </template>
          </ca-tabla>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { CACHE_ACUERDOS_LIBRES_MUTATION_OBTENER_TODOS } from '@/store/acuerdos-libres/acuerdos-libres.types';

export default {
  name:'NuevosConsorcios',
  props: {
    consorcios_pendientes : { type: Array, default: () => []},
  },
  data: () => ({
    consorcios_pendientes_copy: [],
    consorcios_pendientes_filtro: [],
    filtro: '',
    headers: [
      { text: 'Ticket Jira', value: 'jira.informador', class:'col-ticket-jira header-gris' },
      //{ text: 'Descuento', value: 'jira.descuento', class:'col-descuento header-gris' }, // OCULTA TEPMORALMENTE
      { text: 'Estado del cliente', value: 'jira.estado_cliente', class:'col-estado-cliente header-gris' },
      { text: 'Administración', value: 'administracion.nombre', class:'col-administracion' },
      { text: 'Consorcio', value: 'nombre', class:'col-consorcio' },
      { text: 'UFs FACTU.', value: 'cantidad_ufs_facturables', class:'col-ufs' },
      { text: 'Agente', value: 'administracion.agente', class:'col-agente-ventas' },
      { text: 'Creación', value: 'fecha_creacion', class:'col-fecha-creacion' },
      { text: '', value:'', sortable: false} // Columna necesaria, para expadir el total de la tabla y funcione a resoluciones bajas
    ],
    loading_tabla: false, // Flag que indica si la tabla esta cargando (el componente padre lo actualizá cuando es necesario y es usado para mostrar el loading en la tabla)
  }),
  computed: {

    /**
     * Computed que retona un arreglo vacío en caso de loading activo para mostrar empty state, sino retorna los consorcios pendientes filtrados
     */
    itemsTabla() {
      return this.loading_tabla ? [] : this.consorcios_pendientes_filtro;
    },

    /**
     * Computed para calcular el contenido del chip que cuenta cuantos consorcios selecciono
     */
    contenidoChipConsorciosSeleccionados(){
      let chip = {};
      if (this.consorciosSeleccionados.length){
        chip = {
          label: 'Seleccionados: ',
          cant: this.consorciosSeleccionados.length,
        };
      }

      return chip;
    },

    /**
     * Computed para calcular el contenido del chip que cuenta el total de UFs de los consorcios seleccionados
     */
    contenidoChipUfsConsorciosSeleccionados(){
      let chip = {};
      if (this.consorciosSeleccionados.length){

        let total_ufs = 0;
        this.consorciosSeleccionados.forEach((consorcio_seleccionado) => {
          if(consorcio_seleccionado.cantidad_ufs_facturables) {
            total_ufs += consorcio_seleccionado.cantidad_ufs_facturables;
          }
        });

        chip = {
          label: 'UFs: ',
          cant: total_ufs,
        };
      }

      return chip;
    },

    /**
     * Computed para devolver un arreglo con los consorcios que pertencer al arreglo de pendientes y que tiene el atributo seleccionado en true
     */
    consorciosSeleccionados(){
      return this.consorcios_pendientes_copy.filter((consorcio) => consorcio.seleccionado);
    },

    /**
     * Obtengo los acuerdos libres del store
     */
    acuerdosLibresCacheados(){
      return this.$store.getters[CACHE_ACUERDOS_LIBRES_MUTATION_OBTENER_TODOS];
    }
  },
  watch: {

    /**
     * En caso de cambiar los consorcios seleccionados, se emite la actualización.
     */
    consorciosSeleccionados(new_value){
      this.$emit('consorcios-seleccionados:actualizar', new_value);
    },

    /** 
     * Watch de la prop, para matenerla actualizada porque puede cambiar por eliminación o agregar acuerdos vinculados a algunos de estos consorcios
     */
    consorcios_pendientes(new_value){
      this.consorcios_pendientes_copy = _.cloneDeep(new_value);
    },
  },
  mounted(){
    this.consorcios_pendientes_copy = _.cloneDeep(this.consorcios_pendientes);
  },
  methods: {

    /**
     * Metodo que retorna el titulo del tooltip formateado de la administración pasada por parámetro
     */
    tituloTooltipAdministracion(administracion) {
      return '[' + administracion.id + '] ' + administracion.nombre  + ' - ' + administracion.admin_ppal_mail;
    },

    /**
     * Marco el consorcio como seleccionado o no, dependiendo del valor del toggle
     * 
     * @param {Consorcio} consorcio 
     * @param {Boolean} toggle
     */
    seleccionoConsorcio(consorcio, toggle){
      consorcio.seleccionado = toggle;
    },

    /**
     * Metodo que responde al toggle de selección, por si selecciona todo o deselecciona todo
     * 
     * @param { Boolean } selecciono_todo 
     */
    seleccionoTodo(selecciono_todo){
      this.consorcios_pendientes_filtro.forEach((consorcio) => {
        consorcio.seleccionado = selecciono_todo.value;
      });
    },

    /**
     * Metodo encargado emitir evento para abrir el sidesheet de asignación en el padre, si es que hay acuerdos libres disponibles
     * Enviandole el consorcio seleccionado como evento
     */
    abrirSidesheetAsignacionLibres(consorcio_seleccionado){
      if (this.acuerdosLibresCacheados.length){
        this.$emit('consorcio-para-asignar-libre:seleccionado', consorcio_seleccionado);
      }
    },

    /**
     * Metodo encargado emitir evento para indiciar que se desean archivar los consorcios seleccionados
     */
    archivarConsorciosSeleccionados(){
      this.$emit('consorcios-seleccionados:archivar');
    }
  },
};
</script>

<style lang="scss">
#nuevos-consorcios {

  .tabla-container {

    .ca-filtro {
      min-width: 350px;

      .ca-filtro-textfield {
        margin-left: 0;
        margin-right: 0;
      }
    }

    .chip-totalizador {
      height: 26px;

      .v-chip__content {
        background-color: color(dark);
        color: color(blanco);
      }
    }

    .archivar-consorcios {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: color(dark);

      &:hover{
        color: color(naranja);
      }

      .icono-archivar{
        font-size: 20px;
      }

      .label-archivar-consorcios{
        font-size: 13px;
        font-weight: 400;
        line-height: 15.6px;
        text-decoration: underline;
        text-underline-offset: 3px;
      }
    }

    .tabla-nuevos-consorcios {
      max-width: 100%;
      overflow-x: auto;

      margin-top: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 4px 0 rgba(0, 0, 0, 0.12),
        0 1px 5px 0 rgba(0, 0, 0, 0.2);

      .background-fila-seleccionada {
        background-color: color(fondo-claro);
      }

      .v-input--selection-controls {
        margin-top: 0 !important;
      }

      .tabla-checkbox {
        height:20px;
      }

      .icono-link {
        margin-left: 6px;
        color: color(celeste);
      }

      .icono-tipo-consorcio.material-symbols-outlined {
        color: color(gris);
        font-variation-settings:
          'FILL' 1,
          'wght' 400,
          'GRAD' 0,
          'opsz' 24
      }

      th {
        position: sticky;
        z-index: 2;

        &:first-of-type {
          width: 40px !important;
          background-color: color(gris);
        }
        &.col-ticket-jira{
          width: 160px;
          text-overflow: ellipsis;
        }
        &.col-descuento{
          width: 220px;
        }
        &.col-estado-cliente{
          width: 170px;
        }
        &.col-administracion{
          width: 240px;
        }
        &.col-consorcio{
          width: 270px;
        }
        &.col-ufs{
          width: 80px;
        }
        &.col-agente-ventas{
          width: 120px;
        }
        &.col-fecha-creacion{
          width: 100px;
        }
        &.header-gris{
          background-color: color(gris);
        }
      }

      td{
        cursor: default;
      }

      tr:not(:hover) .icono-link {
        display: none;
      }

      tr:hover {
        background-color: color(gris-claro) !important;
      }

      .texto-mostrado{
        max-width: 220px - 20px; // Icono de link
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      /**
       * Se pisa los estilos de la tabla para que se adapte al viewport (el max-height es para poner un tope a la tabla, para evitar que se scrollee en la pagina completa)
       * ToDo - Queda hardocodeado el calculo, investigar / mejorar para hacerlo dinámico.
       */
      .v-data-table__wrapper {
        max-height: calc(100vh - 358px);
      }
    }
  }
}
</style>